"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BVInlineRatingsBase = exports.BVInlineRatings = exports.BVReviewsBase = exports.BVReviews = exports.BVRatingsSummaryBase = exports.BVRatingsSummary = exports.BVInlineRatingsBaseV1 = exports.BVInlineRatingsV1 = exports.BVReviewsBaseV1 = exports.BVReviewsV1 = exports.BVRatingsSummaryBaseV1 = exports.BVRatingsSummaryV1 = exports.withBVLoader = exports.BVLoaderProvider = exports.asEditableBV = exports.asDesignableBVComponent = exports.asBVComponent = exports.asBodilessBV = void 0;

var asBVComponent_1 = __importStar(require("./components/asBVComponent"));

exports.asBVComponent = asBVComponent_1.default;
Object.defineProperty(exports, "asDesignableBVComponent", {
  enumerable: true,
  get: function get() {
    return asBVComponent_1.asDesignableBVComponent;
  }
});

var BVLoader_1 = require("./components/BVLoader");

Object.defineProperty(exports, "BVLoaderProvider", {
  enumerable: true,
  get: function get() {
    return BVLoader_1.BVLoaderProvider;
  }
});
Object.defineProperty(exports, "withBVLoader", {
  enumerable: true,
  get: function get() {
    return BVLoader_1.withBVLoader;
  }
});

var asBodilessBV_1 = require("./components/asBodilessBV");

Object.defineProperty(exports, "asBodilessBV", {
  enumerable: true,
  get: function get() {
    return asBodilessBV_1.asBodilessBV;
  }
});

var asEditableBV_1 = require("./components/asEditableBV");

Object.defineProperty(exports, "asEditableBV", {
  enumerable: true,
  get: function get() {
    return asEditableBV_1.asEditableBV;
  }
});

var BVRatingsSummary_1 = __importStar(require("./components/v1/BVRatingsSummary"));

exports.BVRatingsSummaryV1 = BVRatingsSummary_1.default;
Object.defineProperty(exports, "BVRatingsSummaryBaseV1", {
  enumerable: true,
  get: function get() {
    return BVRatingsSummary_1.BVRatingsSummaryBase;
  }
});

var BVReviews_1 = __importStar(require("./components/v1/BVReviews"));

exports.BVReviewsV1 = BVReviews_1.default;
Object.defineProperty(exports, "BVReviewsBaseV1", {
  enumerable: true,
  get: function get() {
    return BVReviews_1.BVReviewsBase;
  }
});

var BVInlineRatings_1 = __importStar(require("./components/v1/BVInlineRatings"));

exports.BVInlineRatingsV1 = BVInlineRatings_1.default;
Object.defineProperty(exports, "BVInlineRatingsBaseV1", {
  enumerable: true,
  get: function get() {
    return BVInlineRatings_1.BVInlineRatingsBase;
  }
});

var BVRatingsSummary_2 = __importStar(require("./components/v2/BVRatingsSummary"));

exports.BVRatingsSummary = BVRatingsSummary_2.default;
Object.defineProperty(exports, "BVRatingsSummaryBase", {
  enumerable: true,
  get: function get() {
    return BVRatingsSummary_2.BVRatingsSummaryBase;
  }
});

var BVInlineRatings_2 = __importStar(require("./components/v2/BVInlineRatings"));

exports.BVInlineRatings = BVInlineRatings_2.default;
Object.defineProperty(exports, "BVInlineRatingsBase", {
  enumerable: true,
  get: function get() {
    return BVInlineRatings_2.BVInlineRatingsBase;
  }
});

var BVReviews_2 = __importStar(require("./components/v2/BVReviews"));

exports.BVReviews = BVReviews_2.default;
Object.defineProperty(exports, "BVReviewsBase", {
  enumerable: true,
  get: function get() {
    return BVReviews_2.BVReviewsBase;
  }
});